import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/material/styles";
import RotatingCubeLogo from "../pages/HomePage/components/RotatingCubeLogo";
import {
  ACCENT,
  ACCENT_DARK,
  HAIRLINE,
  HAIRLINE_STRONG,
  INK_SECONDARY,
  INK_MUTED,
} from "../theme/tokens";

// Loading bar gradient — sourced from the brand accent so the boot screen
// matches the rest of the app instead of using a one-off green/teal.
const COLORS = {
  green: ACCENT,
  teal: ACCENT_DARK,
  gray: HAIRLINE_STRONG,
};

const progressMove = keyframes`
  0% { transform: translateX(-50%); opacity: 0.5; }
  50% { transform: translateX(100%); opacity: 1; }
  100% { transform: translateX(250%); opacity: 0.5; }
`;

const shineText = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f6f8f9 0%, #eef2f3 100%)",
      }}
    >
      {/* rotating cube */}
      <Box sx={{ width: 96, mb: 4 }}>
        <RotatingCubeLogo size={64} duration={5} />
      </Box>

      <Box
        sx={{
          position: "relative",
          width: 180,
          height: 8,
          borderRadius: 999,
          overflow: "hidden",
          backgroundColor: HAIRLINE,
          mb: 3,
          "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            width: "40%",
            borderRadius: "inherit",
            background: `linear-gradient(90deg, ${COLORS.green}, ${COLORS.teal}, ${COLORS.gray})`,
            animation: `${progressMove} 1.6s ease-in-out infinite`,
          },
        }}
      />

      <Typography
        variant="body1"
        sx={{
          fontWeight: 600,
          letterSpacing: 0.6,
          fontSize: 18,
          color: INK_SECONDARY,
          overflow: "hidden",
          background: `linear-gradient(90deg, ${INK_SECONDARY} 0%, ${INK_MUTED} 20%, ${INK_SECONDARY} 40%)`,
          backgroundSize: "200% 100%",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          animation: `${shineText} 2s linear infinite`,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;
